/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Confirmpassword1Inputs */

const zh_auth_confirmpassword1 = /** @type {(inputs: Auth_Confirmpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认密码`)
};

const en_auth_confirmpassword1 = /** @type {(inputs: Auth_Confirmpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Password`)
};

const es_auth_confirmpassword1 = /** @type {(inputs: Auth_Confirmpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar contraseña`)
};

/**
* | output |
* | --- |
* | "Confirm Password" |
*
* @param {Auth_Confirmpassword1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_confirmpassword1 = /** @type {((inputs?: Auth_Confirmpassword1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Confirmpassword1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_confirmpassword1(inputs)
	if (locale === "en") return en_auth_confirmpassword1(inputs)
	return es_auth_confirmpassword1(inputs)
});
export { auth_confirmpassword1 as "auth_confirmPassword" }